import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { ArticleRow } from '../components/blocks/ArticleRow';
import { FeatureArticle } from '../components/blocks/FeatureArticle';
import { Container } from '../components/primitives/Container';
import { SectionHead } from '../components/primitives/SectionHead';
import { useContent } from '../content/load';
import { useDocumentTitle } from '../lib/seo';

const Tabs = styled.nav`
  display: flex;
  gap: 8px;
  border-bottom: 1px solid ${(p) => p.theme.color.border.faint};
  padding-bottom: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const Tab = styled.button<{ $active?: boolean }>`
  background: transparent;
  border: 1px solid ${(p) => (p.$active ? p.theme.color.accent.amber : p.theme.color.border.med)};
  color: ${(p) => (p.$active ? p.theme.color.accent.amber : p.theme.color.text[1])};
  padding: 6px 12px;
  border-radius: 999px;
  font-size: ${(p) => p.theme.step[1]}px;
`;

const cats = ['All', 'Research', 'Market Note', 'Technical'] as const;

export default function Research() {
  const { articles, pages } = useContent();
  useDocumentTitle(pages.research?.seo.title, pages.research?.seo.description);
  const [params, setParams] = useSearchParams();
  const cat = params.get('cat') ?? 'All';
  const filtered = cat === 'All' ? articles : articles.filter((a) => a.cat === cat);
  const hero = filtered.find((a) => a.hero) ?? filtered[0];
  const list = filtered.filter((a) => a !== hero);

  return (
    <Container>
      <SectionHead eyebrow="RESEARCH" heading="Notes from the desk." />
      <Tabs>
        {cats.map((c) => (
          <Tab
            key={c}
            $active={cat === c}
            onClick={() =>
              setParams(c === 'All' ? {} : { cat: c }, { replace: true })
            }
          >
            {c}
          </Tab>
        ))}
      </Tabs>

      {hero && <FeatureArticle article={hero} />}

      <div style={{ marginTop: 24 }}>
        {list.map((a) => (
          <ArticleRow key={a.id} article={a} />
        ))}
        {list.length === 0 && <p style={{ opacity: 0.7 }}>No articles in this category.</p>}
      </div>
    </Container>
  );
}
